import { searchObjectQuery, showSearchBar } from 'app/atoms';
import { FooterWithoutLinks } from 'app/components/web/explorer-layout';
import { Column } from 'app/design/primitives/box';
import { WhiteLabel } from 'app/types/white-labels';
import { isWhiteLabel } from 'app/utils/helpers';
import { useHeaderHeight } from '@react-navigation/elements';
import { useAtom, useAtomValue } from 'jotai';
import type { NativeScrollEvent, NativeSyntheticEvent } from 'react-native';
import { useWindowDimensions } from 'react-native';
import { ScrollView } from 'react-native-gesture-handler';
import { DesjardinsModalPrompt } from './components/desjardins-modal-prompt';
import { ImmatureNeighbourhoodSections } from './components/immature-neighbourhood-sections';
import { LandingDiscoverySections } from './components/landing-discovery-sections';
import { LandingOverviewSections } from './components/landing-overview-sections';
import { LandingCategoryOffers, useLandingCategoryOffers } from './components/landing-category-offers';
import { landingPageLargeStyles as styles } from './large-styles';
import { useDesktopLandingData } from './use-desktop-landing-data';

export function LandingPageContent() {
  const [, setShowSearchBar] = useAtom(showSearchBar);
  const searchQuery = useAtomValue(searchObjectQuery);
  const categoryOffers = useLandingCategoryOffers();
  const headerHeight = useHeaderHeight();
  const { height: windowHeight } = useWindowDimensions();
  const scrollViewHeight = Math.max(0, windowHeight - headerHeight);
  const data = useDesktopLandingData();

  const handleScroll = (event: NativeSyntheticEvent<NativeScrollEvent>) => {
    const { contentOffset, contentSize, layoutMeasurement } = event.nativeEvent;
    setShowSearchBar(searchQuery.length > 0 || contentOffset.y > 429);

    if (contentOffset.y + layoutMeasurement.height >= contentSize.height - 300) {
      categoryOffers.loadMore();
    }
  };

  return (
    <ScrollView
      contentContainerStyle={styles.scrollViewContent}
      nestedScrollEnabled
      onScroll={handleScroll}
      scrollEventThrottle={30}
      showsVerticalScrollIndicator
      style={[styles.scrollView, { height: scrollViewHeight, maxHeight: scrollViewHeight }]}
    >
      <Column style={styles.page} rowGap="spacing.general.x8" testID="landing-page-screen">
        <LandingOverviewSections data={data} />
        {isWhiteLabel(WhiteLabel.Refrain) ? (
          <LandingCategoryOffers
            query={categoryOffers}
            onCategoryPress={data.actions.openOfferCategory}
            variant="large"
          />
        ) : null}
        {!data.isNeighbourhoodStatusPending ? (
          data.isImmatureNeighbour && !isWhiteLabel(WhiteLabel.HauteGaspesie) ? (
            <ImmatureNeighbourhoodSections data={data} />
          ) : (
            <LandingDiscoverySections data={data} />
          )
        ) : null}

        <DesjardinsModalPrompt />
      </Column>
      <FooterWithoutLinks />
    </ScrollView>
  );
}
